module.exports = __webpack_public_path__ + "media/message.17fa49d6.ogg";